import axios from "axios";
import { Base_URL } from "../url";

export const fetchACHDDataWithUTR = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/PayrollHeaderItem/GetACHDdataWithUTR`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching ACHD data with UTR!";
  }
};

export const fetchACHDData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/PayrollHeaderItem/GetACHDdata?skip=0&chunkSize=100`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching ACHD data!";
  }
};

// Api/AchdDataWithUTR.js
export const fetchACITDataByDocno = async (docno) => {
  try {
    const response = await axios.get(
      `${Base_URL}/PayrollHeaderItem/GetAcitData`,
      {
        params: { Docno: docno },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching ACIT data by docno!";
  }
};

export const fetchAcitDataForAll = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/PayrollHeaderItem/GetAcitDataForAll`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching ACIT data for all!";
  }
};
